import Blocks from "@/components/Blocks"

export default function TextBlockHeading({ block }) {
  if (block.innerBlocks.length === 0) {
    return null
  }

  return (
    <div className="heading">
      <Blocks
        blocks={block.innerBlocks}
        settings={{ "core/heading": { width: "bleed" } }}
      />
    </div>
  )
}
